import { UserRole } from 'generated/graphql';

const allRoles = ['Administrator', 'Lead', 'Organizer', 'Activist'];
const ADMINISTRATOR = 'ADMINISTRATOR';

const allRolesUpper = allRoles.map(x => x.toUpperCase());

const isValidRole = (role: UserRole) => {
  if (allRolesUpper.includes(role.toUpperCase()) === false) {
    console.error(`Role ${role} is invalid`);
    return false;
  }
  return true;
};

const roleIsGreaterThan = (role: UserRole, compareWith: UserRole): boolean => {
  if (!isValidRole(role) || !isValidRole(compareWith)) {
    return false;
  }

  const roleUpper = role.toUpperCase();
  const compareWithUpper = compareWith.toUpperCase();

  const currentUserIndex = allRolesUpper.indexOf(roleUpper);
  const compareWithIndex = allRolesUpper.indexOf(compareWithUpper);

  return currentUserIndex < compareWithIndex;
};

/**
 * When two valid roles are given checks if first role is
 * greater than or equal to second role.
 *
 * @param currentUserRole
 * @param compareWith
 */
const roleIsGreaterEqThan = (role: UserRole, compareWith: UserRole): boolean => {
  const isGreater = roleIsGreaterThan(role, compareWith);
  if (isGreater) {
    return isGreater;
  }
  if (!isValidRole(role) || !isValidRole(compareWith)) {
    return false;
  }

  return role.toUpperCase() === compareWith.toUpperCase();
};

const getAssignableRoles = (currentUserRole: UserRole) => {

  // Order matters here. Roles are listed in order of privlege.

  // If current user role is not in the list
  // then return empty list of roles.
  if (isValidRole(currentUserRole) === false) {
    return [];
  }

  if (currentUserRole.toUpperCase() === ADMINISTRATOR) {
    return allRoles;
  }

  // Get the index of the current roll
  const userRoleIndex = allRolesUpper.indexOf(currentUserRole.toUpperCase()) + 1;

  // Slice off everything before it
  const result = allRoles.slice(userRoleIndex);
  return result;
};

export { allRoles, isValidRole, roleIsGreaterEqThan, roleIsGreaterThan, getAssignableRoles };
